import { useEffect } from 'react'
import useEP from './useEP'
import { getMemories } from '../services/services'

const useMemories = ({ personId }) => {
  const [state, dispatch, fn] = useEP(getMemories)

  useEffect(() => {
    if (personId) {
      dispatch({ type: 'load' })
    }
  }, [dispatch, personId])

  useEffect(() => {
    if (state.load) {
      getMemories({ personId }).then((res) => {
        dispatch({ type: 'complete', res })
      })
    }
  }, [dispatch, personId, state.load])

  return [state, dispatch, fn]
}
export default useMemories
